import { EntidadeBase } from 'hay-core-react';
class LinkModel extends EntidadeBase {
  constructor() {
    super('link');
  }
}

export default new LinkModel();
